<template>
  <div class="row">
    <div v-if="!notes.length" class="col-12 text-center my-5">
      Aucune note d'enregistrée pour cette valeur.
    </div>
    <div v-if="notes.length" class="col-12">
      <div>
        <base-table :data="notes" thead-classes="text-primary">
          <template slot="columns">
            <th style="width: 200px">Date</th>
            <th class="text-left">Note</th>
            <th class="text-center">Action</th>
            <th></th>
          </template>
          <template slot-scope="{ row }">
            <td>
              <h5 class="">
                {{ $moment(row.data.t * 1000).format("lll") }}
              </h5>
            </td>
            <td>
              <pre class="">{{ row.data.content }}</pre>
            </td>
            <td class="text-center" style="width: 80px">
              <i
                class="text-warning pointer tim-icons icon-trash-simple"
                @click="removeNoteClick(row)"
              ></i>
            </td>
          </template>
        </base-table>
      </div>
      <div class="text-center text-muted mt-4" v-if="!conf.isPro">
        Vous ne pouvez consulter que la dernière note enregistrée.<br />
        <router-link class="pointer text-primary ml-4" tag="b" to="/pro">
          <b>Passer pro</b>
        </router-link>
        pour consulter toutes les notes.
      </div>
    </div>
    <div class="col-12 text-center mt-4">
      <button
        type="button"
        class="btn btn-warning text-center btn-sm "
        @click="newNote()"
      >
        Ajouter une nouvelle note
      </button>
    </div>
  </div>
</template>

<script>
import { BasePagination, BaseTable } from "src/components";
import { mapGetters } from "vuex";
import { addNote, deleteNote, searchNotes } from "../../../dao/firestore";

export default {
  name: "notesTable",
  props: {
    instrument: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    BasePagination,
    BaseTable
  },
  computed: {
    ...mapGetters({
      conf: "auth/conf",
      user: "auth/user",
      mode: "auth/mode"
    })
  },
  data() {
    return {
      notes: []
    };
  },
  methods: {
    async init(instrument) {
      if (!instrument) return;
      this.notes = await searchNotes(
        this.user,
        instrument,
        this.mode,
        this.conf.isPro ? 50 : 1
      );
    },
    async removeNoteClick(note) {
      await deleteNote(note.uid);
      await this.init({ isin: note.data.isin });
    },
    async newNote() {
      this.$swal({
        input: "textarea",
        title: "Nouvelle note",
        text: "",
        inputPlaceholder: "",
        icon: "info",
        showCancelButton: true,
        confirmButtonText: "Ajouter",
        cancelButtonText: "Ignorer",
        showCloseButton: true
      }).then(async result => {
        if (result.isConfirmed) {
          await addNote(this.user, {
            content: result.value,
            mode: this.mode,
            isin: this.instrument.isin
          });
          this.$swal(
            "C'est fait !",
            "Votre note a été ajoutée avec succès.",
            "success"
          );
          await this.init(this.instrument);
        }
      });
    }
  },
  async mounted() {
    await this.init(this.instrument);
  },
  watch: {
    async instrument(newValue, oldValue) {
      if (
        (newValue && oldValue && newValue.isin != oldValue.isin) ||
        !oldValue
      ) {
        await this.init(newValue);
      }
    }
  }
};
</script>

<style scoped></style>
